<template>
  <a-card :title="project_title" size="small">
    <div :id="project_title" :style="{ height: height, width: width }" />
  </a-card>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {
          version_id: 1,
          user_group: 1
        };
      }
    },
    // eslint-disable-next-line vue/prop-name-casing
    project_title: {
      type: String,
      default: ''
    },
    failed: {
      type: Array,
      default: () => {
        return [];
      }
    },
    success: {
      type: Array,
      default: () => {
        return [];
      }
    },
    taskMap: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      option: {
        legend: {
          // Try 'horizontal'
          orient: 'vertical',
          right: 10,
          data: ['成功数(次)', '失败数(次)']
        },
        xAxis: [
          {
            data: ['编译', '单测', '单测覆盖率', '功能测试', '流水线']
          }
        ],
        yAxis: {},
        series: [
          {
            name: '成功数(次)',
            type: 'bar',
            data: [],
            stack: 'x',
            barWidth: '50%',
            label: {
              show: true,
              position: 'inside',
              color: 'black'
            }
          },
          {
            name: '失败数(次)',
            data: [],
            type: 'bar',
            itemStyle: {
              color: 'rgb(200, 50, 10)'
            },
            stack: 'x',
            label: {
              show: true,
              position: 'inside',
              color: 'black'
            }
          }
        ]
      }
    };
  },
  watch: {
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 饼图
    require('echarts/lib/chart/line'); // 饼图
    // 下面的是需要的提示框
    require('echarts/lib/component/grid');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    this.myChart = echarts.init(document.getElementById(this.project_title));
    this.option.series[0].data = this.success;
    this.option.series[1].data = this.failed;
    this.drawChart();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    }
  }
};
</script>
